import React from "react";

import { TextInputField, SwitchField, TagsInput } from "../../../components/FormField";
import SoftBox from "../../../components/SoftBox";
import SoftButton from "../../../components/SoftButton";

import { filterPanelStyles } from "../../../examples/Tables/styles";

/** Existing scheduler filters use the same compact tray as the other report tables. */
const Filters = () => {
  return (
    <SoftBox
      sx={(theme) => ({
        ...filterPanelStyles(theme),
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
        "& .MuiAutocomplete-inputRoot": { height: "auto", minHeight: 40 },
        "& .MuiAutocomplete-root > .MuiBox-root": { mb: 0 },
      })}
    >
      <TextInputField label="Report Name" name="name" />
      <TagsInput name="emails" label="Emails" />
      <SoftBox
        sx={{
          gridColumn: "1 / -1",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1.5,
        }}
      >
        <SwitchField name="onlyDeleted" label="Get the soft deleted reports" />
        <SoftButton variant="gradient" color="info" type="submit" size="small">
          Search
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
};

export default Filters;
